import styled from 'styled-components';

import { Card } from '@xing-com/card';
import type { JobSalary } from '@xing-com/crate-common-graphql-types';
import { isValidSalaryEstimate } from '@xing-com/crate-jobs-helpers';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

import { SalaryEstimation } from './salary-estimation';

const SalaryContainer = styled(Card)`
  width: 100%;

  /* remove all card styles on small screen */
  @media ${mediaSmallOrTiny} {
    background-color: transparent;
    border: none;
    padding: 0;
  }
`;

type Props = {
  salary?: JobSalary | null;
};

export const SalaryModule: React.FC<Props> = ({ salary }) => {
  return isValidSalaryEstimate(salary) ? (
    <SalaryContainer data-testid="job-details-salary-card">
      <SalaryEstimation salary={salary} />
    </SalaryContainer>
  ) : null;
};
